import _ from 'underscore';
import React, { useState, useEffect, useCallback } from 'react';

import Lightbox from 'components/Lightbox';

export function useLightbox(materials) {
	const [toggler, setToggler] = useState(false);
	const [slideNumber, setSlideNumber] = useState(0);

	const onClick = useCallback((index) => {
		if (_.isNumber(index)) {
			setSlideNumber(index + 1);
		} else {
			setSlideNumber(1);
		}
	}, []);

	const onClose = useCallback(() => {
		setSlideNumber(0);
	}, []);

	useEffect(() => {
		if (slideNumber) {
			setToggler((prevState) => !prevState);
		}
	}, [slideNumber]);

	const lightbox = (
		<Lightbox
			materials={materials}
			onClose={onClose}
			toggler={toggler}
			slide={slideNumber}
		/>
	);

	return [lightbox, onClick];
}
